import { styled, Button } from '@mui/material';

export const CopyToClipboardButton = styled(Button)`
    background: #FFF;
    padding: 0;
    margin: 0 0 0 5px;
    min-width: 0;
    &:active {
    }
`;